import { render, staticRenderFns } from "./Replay2D.vue?vue&type=template&id=5cb9bed5&scoped=true&"
import script from "./Replay2D.vue?vue&type=script&lang=js&"
export * from "./Replay2D.vue?vue&type=script&lang=js&"
import style0 from "./Replay2D.vue?vue&type=style&index=0&id=5cb9bed5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb9bed5",
  null
  
)

export default component.exports